import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDeliveryTarget } from 'src/app/core/models/i-delivery-target';
import { RestService } from 'src/app/shared/services/rest-service';

@Injectable({
  providedIn: 'root',
})
export class DeliveryTargetsService {
  static readonly ENTITY_IDENTIFIER: string = 'delivery-targets';
  private readonly BASE_DELIVERY_TARGETS_ROUTE = `api/${DeliveryTargetsService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(
      this.BASE_DELIVERY_TARGETS_ROUTE,
      ...args,
    );

  constructor(private restService: RestService) {}

  // TODO IMPROVEMENT: Could be just a wrapper of getFilterd$ with no filters.
  getAll$(): Observable<IDeliveryTarget[]> {
    return this.restService.get$<IDeliveryTarget[]>(this.BUILD_HTTP_ROUTE());
  }

  // TODO BACKEND: CMS-1533 - Filter data from the backend (not sure by what)
  getFiltered$(): Observable<IDeliveryTarget[]> {
    return this.restService.get$<IDeliveryTarget[]>(this.BUILD_HTTP_ROUTE());
  }
}
